// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"95bccb07","337":"182386b9","455":"b9ba2d44"}[chunkId] + ".chunk.js";
};